import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import {
  getAdvertisementsApi,
} from "../../api/ClientActions";

interface AdvertisementConfig {
  config_id?: number;
  client_id?: number | null;
  admin_display_after_posts?: number;
  client_display_after_posts?: number;
  display_position?: string;
  show_admin_ads?: number;
  show_client_ads?: number;
  status?: number;
  added_on?: string | null;
}

interface AdvertisementState {
  loading: boolean;
  advertisements: any[];
  adminAdvertisements: any[];
  clientAdvertisements: any[];
  config: AdvertisementConfig | null;
  error: string | null;
}

const initialState: AdvertisementState = {
  loading: false,
  advertisements: [],
  adminAdvertisements: [],
  clientAdvertisements: [],
  config: null,
  error: null,
};

// ==========================
// GET ADVERTISEMENTS
// Same thunk for guest and logged-in users
// ==========================
export const getAdvertisements =
  createAsyncThunk(
    "advertisements/getAdvertisements",

    async (
      userId: number | null | undefined,
      { rejectWithValue }
    ) => {
      try {
        const res =
          await getAdvertisementsApi(
            userId
          );

        const adminAdvertisements =
          Array.isArray(
            res?.admin_advertisements
          )
            ? res.admin_advertisements
            : [];

        const clientAdvertisements =
          Array.isArray(
            res?.client_advertisements
          )
            ? res.client_advertisements
            : [];

        return {
          adminAdvertisements,
          clientAdvertisements,

          advertisements: [
            ...adminAdvertisements,
            ...clientAdvertisements,
          ],

          config: res?.data || null,
        };
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data?.message ||
            error?.message ||
            "Failed to fetch advertisements"
        );
      }
    }
  );

const advertisementSlice =
  createSlice({
    name: "advertisements",

    initialState,

    reducers: {},

    extraReducers: (builder) => {
      builder
        .addCase(
          getAdvertisements.pending,
          (state) => {
            state.loading = true;
            state.error = null;
          }
        )
        .addCase(
          getAdvertisements.fulfilled,
          (state, action) => {
            state.loading = false;
            state.error = null;

            state.adminAdvertisements =
              action.payload
                ?.adminAdvertisements ||
              [];

            state.clientAdvertisements =
              action.payload
                ?.clientAdvertisements ||
              [];

            state.config =
              action.payload?.config ||
              null;

            state.advertisements = (
              action.payload
                ?.advertisements || []
            ).filter(
              (ad: any) =>
                Number(ad.status) === 1 &&
                String(
                  ad.display_position ||
                    ""
                )
                  .trim()
                  .toLowerCase() ===
                  "news_feed"
            );
          }
        )
        .addCase(
          getAdvertisements.rejected,
          (state, action: any) => {
            state.loading = false;
            state.advertisements = [];
            state.adminAdvertisements = [];
            state.clientAdvertisements = [];
            state.config = null;
            state.error =
              action.payload ||
              "Something went wrong";
          }
        );
    },
  });

export default advertisementSlice.reducer;
